import React from "react";
import GenericList from "./GenericList";
import ComboWithOptions from "./ComboWithOptions";

function WorkList(props) {

    function getAdditionalCells(item, index){
        return (
        <ComboWithOptions options={props.data.Zoznam_prac_options} optionDisplay={'Kod_Prace'} select={props.select}
                          value={item.emptyCell? "" :`${item['Vykonana_Praca']['Kod_Prace']}`} ndx={props.ndx} index={index} name='Kod_Prace'
        />
        )
    }

    function getAdditionalEmptyCells(){
        return (
            <ComboWithOptions options={props.data.Zoznam_prac_options} optionDisplay={'Kod_Prace'} select={props.select} value=""
                              ndx={props.ndx} index={null} stateResetOnChange={true} name='Kod_Prace'/>
        )
    }

    return (
        <GenericList label="Zoznam prác"
                     headers={['Popis', 'Kód Práce', 'ks', '€/ks', 'Akcie']}
                     mainColumnName="Popis"
                     list={props.data.Pristroje[props.ndx].Zoznam_Prac}
                     options={props.data.Zoznam_prac_options}
                     optionDisplay={'Popis'}
                     select={props.select}
                     value={props.data.Pristroje[props.ndx].Zoznam_Prac}
                     ndx={props.ndx}
                     update={props.update}
                     delete={props.delete}
                     part={props.data.Pristroje[props.ndx].Zoznam_Prac}
                     singleName="Vykonana_Praca"
                     instanceName="Popis"
                     getAdditionalCells = {getAdditionalCells}
                     getAdditionalEmptyCells = {getAdditionalEmptyCells}
        />
    )
}

export default WorkList
